export type FileStatusType = 'convering' | 'convered' | 'uploading' | 'uploaded'
export interface FileItem {
  file?: File
  uid: string
  base64: string
  status: FileStatusType
}
export interface IConfig {
  /* 连接实例 */
  instance: any
  /* 加载状态 */
  loading: boolean
  /* 是否出错 */
  error: boolean
  /* 当前图片尺寸 */
  scanSize: string
  /* 图片质量列表 */
  priResolutionList: any[]
  /* 当前图片质量 */
  priResolution: string
  /* 预览图base64 */
  priImageData: string
  /* 真实图列表 */
  priPhotoData: FileItem[]
  /* 是否保存到本地 */
  saveToLocal: boolean
  /* 是否去除底色 */
  delBgColor: boolean
  /* 是否纠偏裁边 */
  isDeskew: boolean
}
export interface MianWorkerRc {
  file: File
  uid: string
}
export interface ConverWorkerRc {
  uid: string
  base64: string
}
export const SCAN_SIZE_MAP = {
  setScanSize_ori: '原始尺寸',
  setScanSize_A5: 'A5',
  setScanSize_A4: 'A4',
  setScanSize_A3: 'A3',
  setScanSize_card: '身份证尺寸'
}
